import classNames from "classnames"

export const layoutClassNames = classNames(
  "overflow-x-hidden flex flex-col justify-between min-h-screen"
)
